/*
================================================================================
File: src/pages/Links.js
Description: A page that shows an external link and prompts the user to navigate to it.
================================================================================
*/
import React, { useEffect } from 'react';
import PageContent from '../components/common/PageContent';

const Links = ({ view }) => {
  useEffect(() => {
    // Automatically open the link in a new tab when the component mounts
    if (view) {
      window.open(view, "_blank", "noopener,noreferrer");
    }
  }, [view]);

  return (
    <PageContent title="External Links" error={null}>
      <div className="flex flex-col px-5 py-3 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 m-10 shadow-md">
        <div>
          <h3 className="text-xl font-semibold mb-2 text-blue-600 dark:text-blue-400">
            Redirecting...
          </h3>
          <p>You are being redirected to an external site. If your browser has not opened a new tab, please click the link below.</p>
          <a href={view} target="_blank" rel="noopener noreferrer" className="text-blue-700 dark:text-blue-400 hover:underline dark:hover:text-blue-300 break-all">
            {view}
          </a>
        </div>
      </div>
    </PageContent>
  );
};

export default Links;